import { render, staticRenderFns } from "./MyCol.vue?vue&type=template&id=f894b9b4&"
import script from "./MyCol.vue?vue&type=script&lang=js&"
export * from "./MyCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports